import VehiculeAutomoteur from "./indicators/VehiculeAutomoteur";
import PartPopulationDesserteTc from "./indicators/PartPopulationDesserteTc";
import ParcBus from "./indicators/ParcBus";
import Aeropuerto from "./layers/Aeropuerto";
import EstacionFerroviaria from "./layers/EstacionFerroviaria";
import ParadasBus from "./layers/ParadasBus";
import ParadasBusBuffer from "./layers/ParadasBusBuffer";
import RutasBus from "./layers/RutasBus";
import TerminalTerrestre from "./layers/TerminalTerrestre";
import VitesseCommercialeBus from "./indicators/VitesseCommercialeBus";
import InfrastructureCyclable from "./indicators/InfrastructureCyclable";

const MobilityOffer = {
    idSection: "mobilityOffer",
    questionSection: "",
    treeviews: {
        title: "Mobility Indicators Content.sections.MobilityOffer",
        indicators: {
            checked: 0,
            expand: false,
        },
        layers: {
            checked: 2,
            expand: true,
        },
    },
    layers: {
        aeropuerto: Aeropuerto,
        estacionFerroviaria: EstacionFerroviaria,
        paradasBus: ParadasBus,
        paradasBusBuffer: ParadasBusBuffer,
        rutasBus: RutasBus,
        terminalTerrestre: TerminalTerrestre,
    },
    indicators: {
        parcBus: ParcBus,
        vitesseCommercialeBus: VitesseCommercialeBus,
        vehiculeAutomoteur: VehiculeAutomoteur,
        partPopulationDesserteTc: PartPopulationDesserteTc,
        infrastructureCyclable: InfrastructureCyclable,
    },
};

export default MobilityOffer;
